module.exports = __webpack_public_path__ + "img/disney.24ed3a62.svg";